// The frame around the prize doors, shared with the member benefit tiles so they match.
export const FRAME_GRADIENT = 'linear-gradient(90deg, #864D93, #5D4B9C)';
// Tailwind's gray to dark-gray, for prizes that are not open for entries.
export const MUTED_FRAME_GRADIENT = 'linear-gradient(90deg, #CCCCCC, #696969)';

// "r, g, b" strings for use in rgba().
export const GLOW = '156, 80, 254';
// Tailwind's dark-gray.
export const MUTED_GLOW = '105, 105, 105';

/**
 * The glow off two opposite corners of an open prize door or a framed tile.
 * @param {string} glow An "r, g, b" string.
 * @returns {string} A box-shadow value.
 */
export const getFrameGlow = glow =>
  `12px -12px 36px -12px rgba(${glow}, 0.9), -12px 12px 36px -12px rgba(${glow}, 0.9)`;

// The page's section headings, so the prizes and member benefits read as equals. The
// phone size fits a 14-letter word such as "Medlemsfordele" on a 375px screen.
export const sectionHeadingClassName =
  'm-0 hyphens-auto break-words text-[34px] font-extrabold uppercase leading-[0.95] tracking-[-1px] text-black antialiased md:text-[56px] md:tracking-[-2px] xl:text-[72px]';
